import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { loadTasks } from '../thunks/load-annotation-tasks-list.thunks';
import { useFilters, useGlobalFilter, useSortBy, useTable } from 'react-table';
import {
  activeAnnotationTasksSelector,
  endDateParamsSelector,
  inactiveAnnotationTasksSelector,
  searchParamsSelector,
  selectedAnnotatorsSelector,
  selectedEffortsSelector,
  selectedGridsSelector,
  startDateParamsSelector,
} from '../selectors/admin.selectors';
import { setColumns } from '../components/dashboard/AnnotationTaskColumns';
import { AnnotationTask } from '../../ecg/types/annotation-tasks.type';

export const useAnnotationTaskData = (status: string, currentPage: number) => {
  const dispatch = useDispatch();
  const activeAnnotationTasks = useSelector(activeAnnotationTasksSelector);
  const inactiveAnnotationTasks = useSelector(inactiveAnnotationTasksSelector);
  const startDate = useSelector(startDateParamsSelector);
  const endDate = useSelector(endDateParamsSelector);
  const searchInput = useSelector(searchParamsSelector);
  const selectedAnnotators = useSelector(selectedAnnotatorsSelector);
  const selectedGrids = useSelector(selectedGridsSelector);
  const selectedEfforts = useSelector(selectedEffortsSelector);
  const columns = useMemo(() => setColumns, []);

  useEffect(() => {
    dispatch(
      loadTasks(
        status,
        currentPage,
        startDate,
        endDate,
        searchInput,
        selectedAnnotators,
        selectedGrids,
        selectedEfforts,
      ),
    );
  }, [
    dispatch,
    status,
    currentPage,
    startDate,
    endDate,
    searchInput,
    selectedAnnotators,
    selectedGrids,
    selectedEfforts,
  ]);

  const data =
    status === 'ongoing' ? activeAnnotationTasks : inactiveAnnotationTasks;

  const instance = useTable<AnnotationTask>(
    {
      columns,
      data,
      autoResetPage: false,
      autoResetFilters: false,
      autoResetSortBy: false,
      autoResetGlobalFilter: false,
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
  );

  return instance;
};
